import { useEffect } from 'react'
import { Button } from './Button'

export function Modal({
  open,
  onClose,
  title,
  children,
  footer,
  size = 'md',
  closeOnBackdrop = true,
}) {
  useEffect(() => {
    if (!open) return

    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.()
    }

    document.addEventListener('keydown', onKey)
    document.body.style.overflow = 'hidden'

    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = ''
    }
  }, [open, onClose])

  if (!open) return null

  const widths = {
    sm: 'max-w-md',
    md: 'max-w-xl',
    lg: 'max-w-3xl',
    xl: 'max-w-[920px]',
  }

  return (
    <div
      className="fixed inset-0 z-[99999] flex items-stretch justify-end"
      role="dialog"
      aria-modal="true"
      aria-labelledby={title ? 'modal-title' : undefined}
    >
      <button
        type="button"
        className="absolute inset-0 bg-slate-900/45 backdrop-blur-[2px]"
        aria-label="Close dialog"
        onClick={() => closeOnBackdrop && onClose?.()}
      />

      <div
        className={`relative z-[100000] h-full w-full ${widths[size]} bg-white shadow-2xl flex flex-col`}
      >
        {title && (
          <div className="flex items-center justify-between px-5 py-4 border-b border-slate-200 bg-white">
            <div>
              <div className="text-[11px] font-bold uppercase tracking-[0.16em] text-slate-500">Workspace</div>
              <h2
                id="modal-title"
                className="text-xl font-extrabold text-slate-900 mt-1"
              >
                {title}
              </h2>
            </div>

            <Button
              variant="ghost"
              size="sm"
              onClick={onClose}
              aria-label="Close"
              className="text-slate-600 hover:bg-slate-100"
            >
              ✕
            </Button>
          </div>
        )}

        <div className={`flex-1 overflow-y-auto bg-white ${title ? 'px-5 py-3' : 'p-4'}`}>
          {children}
        </div>

        {footer && (
          <div className="flex flex-wrap justify-between gap-2 border-t border-slate-200 bg-white px-5 py-3">
            {footer}
          </div>
        )}
      </div>
    </div>
  )
}
